import React, { useContext } from "react";
import styled from "styled-components";
import intl from "react-intl-universal";
import { mdiImport } from "@mdi/js";

import authUtils from "../../script/utils/authUtils";
import logoColorImage from "../../asset/logo-color.png";
import logoWhiteImage from "../../asset/logo-white.png";

import { Svg } from "../components/Svg";
import { UserContext } from "../contexts/UserContext";
import { VersionContext } from "../contexts/VersionContext";

const PageHeaderStyle = styled.div`
    display: flex;
    padding: 0 25px;
    justify-content: space-between;
    color: ${props => props.theme.white};
    background-color: ${props => (props.$basic ? props.theme.white : props.theme.primaryDark)};
    >img {
        padding: 10px 0;
    }
    >div {
        display: grid;
        align-items: center;
        justify-items: center;
        grid-template-columns: 160px 60px 100px;
    }
`;

const UsernameStyle = styled.div`
    justify-self: end;
`;

const VersionStyle = styled.div`
    justify-self: center;
`;

const LogoutStyle = styled.div`
    display: flex;
    justify-self: end;
    align-items: center;
    cursor: pointer;
    label {
        text-transform: uppercase;
    }
    &:hover {
        color: ${props => props.theme.primaryLighter};
    }
`;

export const PageHeader = React.memo(({ basic }) => {

    const userContext = useContext(UserContext);
    const versionContext = useContext(VersionContext);

    return (
        <PageHeaderStyle $basic={basic}>
            {basic &&
                <img src={logoColorImage} width="280" height="40" />
            }
            {!basic &&
                <>
                    <img src={logoWhiteImage} width="280" height="40" />
                    <div>
                        <UsernameStyle>{userContext.user?.username}</UsernameStyle>
                        <VersionStyle>{versionContext.appVersion}</VersionStyle>
                        <LogoutStyle onClick={() => authUtils.logout()} >
                            <Svg path={mdiImport} size="18" />
                            <label id="logoutLink">{intl.get("header.logout")}</label>
                        </LogoutStyle>
                    </div>
                </>
            }
        </PageHeaderStyle>
    );
});